// import { useState, useEffect, useRef } from 'react';
// import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
// import axios from 'axios';
// import ClientMaster from '../../ClientMaster';
// import LeadSourceMaster from './LeadSourceMaster';
// import ActivityMaster from './ActivityMaster';
// import CurrencyMaster from '../../CurrencyMaster';
// import LeadStatusMaster from './LeadStatusMaster';
// import UserMaster from '../../UserMaster';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import { useAuth } from '../../../context/AuthContext';
// import { useTheme, useMediaQuery } from '@mui/material';
// import { toProperCase } from '../../../utils/formatRows';


// const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));

// export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, disablePartyName = false }) {

//     const { user, selectedCompany, loading } = useAuth();
//     const API = connectionString;
//     const partyDropdownRef = useRef(null);

//     const userId = user?.UserId || null;
//     const companyId = selectedCompany?.CompId || null;
//     const userCategory = user?.UserCategory || null;
//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//     // â”€â”€â”€ client search state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const [companyName, setCompanyName] = useState(initialData.companyName || '');
//     const [selectedClientId, setSelectedClientId] = useState(initialData.clientId || null);
//     const [searchResults, setSearchResults] = useState([]);
//     const [dropdownOpen, setDropdownOpen] = useState(false);
//     const [clientError, setClientError] = useState(false);


//     const [transactionType, setTransactionType] = useState(initialData.transactionType || '')
//     const isTransactionTypeValid = Boolean(transactionType);
//     const [touchedTxnType, setTouchedTxnType] = useState(false);
//     const [selectedGSTNum, setSelectedGSTNum] = useState("")

//     // â”€â”€â”€ other form state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const [details, setDetails] = useState(initialData.details || []);
//     const [error, setError] = useState('');
//     const [quotationNumber, setquotationNumber] = useState(initialData.quotationNumber || '');
//     const [qoutationDate, setqoutationDate] = useState(() => {
//         if (mode === 'add' || mode === 'ref') return dayjs().startOf('day');
//         if (initialData.inquiryDate && dayjs(initialData.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
//             return dayjs(initialData.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
//         }
//         if (initialData.qoutationDate && dayjs(initialData.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
//             return dayjs(initialData.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
//         }
//         return null;
//     });
//     const [referenceNumber, setReferenceNumber] = useState(initialData.referenceNumber || '');
//     const [referenceDate, setReferenceDate] = useState(() => {
//         const refDateValue = initialData.referenceDate || initialData.RefDate;
//         return refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : null;
//     });
//     const [exchangeRate, setExchangeRate] = useState(initialData.exchangeRate || '');
//     const [qnextFollowUpDate, setqnextFollowUpDate] = useState(() => {
//         return initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().add(7, 'day').startOf('day');
//     });
//     const [kindAttend, setKindAttend] = useState(initialData.kindAttend || '');
//     const [project, setProject] = useState(initialData.project || '');
//     const [agentName, setAgentName] = useState(initialData.agentName || initialData.AgentName || '');
//     const [agentCommission, setAgentCommission] = useState(initialData.AgentComm || initialData.agentCommission || '');
//     const [remark, setRemark] = useState(initialData.remark || initialData.remarks || '');

//     // â”€â”€â”€ masters & popups â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const [currencyOptions, setCurrencyOptions] = useState([]);
//     const [selectedCurrency, setSelectedCurrency] = useState(initialData.selectedCurrency || null);
//     const [selectedLeadSource, setSelectedLeadSource] = useState(initialData.selectedLeadSource || null);
//     const [selectedEmployee, setSelectedEmployee] = useState(initialData.selectedEmployee || null);
//     const [selectedActivity, setSelectedActivity] = useState(initialData.selectedActivity || null);
//     const [selectedStatus, setSelectedStatus] = useState(initialData.selectedStatus || null);
//     const [accountOptions, setAccountOptions] = useState([]);
//     const [selectedAccount, setSelectedAccount] = useState(null);

//     const [openClientPopup, setOpenClientPopup] = useState(false);
//     const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
//     const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
//     const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
//     const [openActivityPopup, setOpenActivityPopup] = useState(false);
//     const [openStatusPopup, setOpenStatusPopup] = useState(false);

//     const [snackbar, setSnackbar] = useState({
//         open: false,
//         message: "",
//         severity: "success"
//     });

//     const requiredAsteriskStyle = {
//         '& .MuiFormLabel-asterisk': {
//             color: 'red',
//         },
//     };

//     const handlePopupClose = (data) => {
//         if (data?.success) {
//             setSnackbar({
//                 open: true,
//                 message: data.message,
//                 severity: "success"
//             });
//         }
//     };

//     // â”€â”€â”€ load auto-generated invoice number â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         if (mode !== 'edit') {
//             fetchReceiptNo('Q');
//         }
//     }, [mode]);

//     async function fetchReceiptNo(code) {
//         try {
//             const { data } = await axios.get(`${API}/api/get-purc-invoice-no`, { params: { companyId } });
//             setquotationNumber(data.BillNumber || '');
//         } catch (err) {
//             console.error('Error fetching invoice number:', err);
//             setquotationNumber('');
//         }
//     }

//       useEffect(() => {
//         // Do NOT auto-change if user has manually selected
//         if (touchedTxnType) return;

//         // Do NOT override edit mode value if it exists
//         if (mode === "edit" && initialData.transactionType) return;

//         // IMPORTANT: GST not yet evaluated
//         if (selectedGSTNum === "") return;

//         if (selectedGSTNum) {
//             setTransactionType("regular");
//         } else {
//             setTransactionType("unregisteredPersons");
//         }
//     }, [selectedGSTNum, touchedTxnType, mode, initialData.transactionType]);

//     // â”€â”€â”€ load master lists â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         const fetchMasters = async () => {
//             try {
//                 const [cur, acc] = await Promise.all([
//                     axios.get(`${API}/currencymaster/search?mode=search`),
//                     axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', companyId } })
//                 ]);
//                 setCurrencyOptions(transform(cur.data || [], 'CurrencyId', 'CurrencySymbol'));
//                 setAccountOptions(transform(acc.data.data || [], 'id', 'FirmName'));
//             } catch (err) {
//                 console.error('Error fetching masters:', err);
//                 setCurrencyOptions([]);
//                 setAccountOptions([]);
//             }
//         };
//         fetchMasters();
//     }, []);

//     // â”€â”€â”€ initialize account selection â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         if (!accountOptions.length || !initialData?.id) {
//             setSelectedAccount(null);
//             return;
//         }
//         const found = accountOptions.find(opt => String(opt.id) === String(initialData.id));
//         setSelectedAccount(found || null);
//     }, [accountOptions, initialData.id]);

//     // â”€â”€â”€ initialize currency selection â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         if (!currencyOptions.length || !initialData?.currencyId) {
//             setSelectedCurrency(null);
//             return;
//         }
//         const found = currencyOptions.find(opt => String(opt.id) === String(initialData.currencyId));
//         setSelectedCurrency(found || null);
//     }, [currencyOptions, initialData.currencyId]);

//     // â”€â”€â”€ fetch search results â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     useEffect(() => {
//         if (!companyName || !dropdownOpen) {
//             setSearchResults([]);
//             return;
//         }
//         const fetch = async () => {
//             try {
//                 const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
//                 setSearchResults(Array.isArray(res.data.data) ? res.data.data : []);
//             } catch (err) {
//                 console.error('Error fetching company search results:', err);
//                 setSearchResults([]);
//             }
//         };
//         fetch();
//     }, [companyName, dropdownOpen]);

//     // â”€â”€â”€ handle row selection in table â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const onSelectResult = r => {
//         setSelectedClientId(r.id);
//         setSelectedGSTNum(r.GSTNo);
//         setTouchedTxnType(false)
//         setCompanyName(r.FirmName || r.companyName || '');
//         setAgentName(r.AgentName || '');
//         setAgentCommission(r.AgentComm || '');
//         setDetails([
//             { label: 'City', value: r.City || '' },
//             { label: 'State', value: r.state || '' },
//             { label: 'mobileNo', value: r.MobileNo || '' },
//             { label: 'Email', value: r.EmailId || '' },
//             { label: 'ContactPerson', value: r.ContactPerson || '' },
//             { label: 'GST No.', value: r.GSTNo || '' }
//         ]);
//         setDropdownOpen(false);
//         setClientError(false);
//     };

//     // â”€â”€â”€ dropdownField with popup support â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const dropdownField = (label, options, value, setValue) => (
//         <Grid item xs={12} sm={8} md={12}>
//             <Autocomplete
//                 fullWidth
//                 options={options}
//                 getOptionLabel={opt => opt?.label || ''}
//                 value={value}
//                 onChange={(_, v) => setValue(v)}
//                 isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
//                 disabled={!isEditable}
//                 renderInput={params => (
//                     <TextField
//                         {...params}
//                         label={label}
//                         size="small"
//                         InputLabelProps={{ shrink: Boolean(value) }}
//                         sx={{
//                             '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                             '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                         }}
//                     />
//                 )}
//             />
//         </Grid>
//     );


//     // â”€â”€â”€ initialize from initialData â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     // useEffect(() => {
//     //     if (!initialData || Object.keys(initialData).length === 0) {
//     //         if (mode === 'add' || mode === 'ref') {
//     //             setqoutationDate(dayjs().startOf('day'));
//     //             setReferenceNumber('');
//     //             setReferenceDate(null);
//     //         }
//     //         return;
//     //     }
//     //     if (mode === 'add' || mode === 'ref') {
//     //         setqoutationDate(dayjs().startOf('day'));
//     //     }
//     //     setCompanyName(initialData.companyName || '');
//     //     setSelectedClientId(initialData.clientId ?? null);
//     //     if (initialData.details) {
//     //         if (Array.isArray(initialData.details)) {
//     //             setDetails(initialData.details);
//     //         } else if (typeof initialData.details === 'object') {
//     //             setDetails(Object.entries(initialData.details).map(([label, value]) => ({ label, value })));
//     //         }
//     //     } else {
//     //         setDetails([
//     //             { label: 'City', value: initialData.city || '' },
//     //             { label: 'State', value: initialData.state || '' },
//     //             { label: 'mobileNo', value: initialData.mobileNo || '' },
//     //             { label: 'Email', value: initialData.emailId || '' },
//     //             { label: 'ContactPerson', value: initialData.contactPerson || '' },
//     //             { label: 'GST No.', value: initialData.gstNumber || '' }
//     //         ]);
//     //     }
//     //     setSelectedLeadSource(initialData.selectedLeadSource || null);
//     //     setSelectedEmployee(initialData.selectedEmployee || null);
//     //     setSelectedActivity(initialData.selectedActivity || null);
//     //     setSelectedStatus(initialData.selectedStatus || null);
//     //     if (mode === 'edit') {
//     //         const inquiryDate = initialData.inquiryDate || initialData.qoutationDate;
//     //         setqoutationDate(inquiryDate && dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().startOf('day'));
//     //         setquotationNumber(initialData.quotationNumber || '');
//     //     }
//     //     if (mode !== 'add') {
//     //         setReferenceNumber(initialData.referenceNumber || '');
//     //         const refDateValue = initialData.referenceDate || initialData.RefDate;
//     //         setReferenceDate(refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : null);
//     //     }
//     //     if (mode === "ref") {
//     //         setReferenceNumber(initialData.quotationNumber || '');
//     //     }
//     //     setExchangeRate(initialData.exchangeRate || '');
//     //     setqnextFollowUpDate(initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().add(7, 'day').startOf('day'));
//     //     setKindAttend(initialData.kindAttend || '');
//     //     setProject(initialData.project || '');
//     //     setAgentName(initialData.AgentName || initialData.agentName || '');
//     //     setAgentCommission(initialData.AgentComm || initialData.agentCommission || '');
//     //     setRemark(initialData.remark || initialData.remarks || '');
//     // }, [initialData, mode]);

//     useEffect(() => {
//         if (!initialData || Object.keys(initialData).length === 0) {
//             if (mode === 'add' || mode === 'ref') {
//                 setqoutationDate(dayjs().startOf('day'));
//                 setReferenceNumber('');
//                 setReferenceDate(null);
//             }
//             return;
//         }

//         // âœ… ONLY override date in 'add' mode, NOT in 'ref' mode
//         if (mode === 'add') {
//             setqoutationDate(dayjs().startOf('day'));
//         }

//         // Set company name from initialData
//         setCompanyName(initialData.companyName || '');

//         // Set clientId from initialData
//         setSelectedClientId(initialData.clientId ?? null);

//         // Rest of code stays same...
//         if (initialData.details) {
//             if (Array.isArray(initialData.details)) {
//                 setDetails(initialData.details);
//             } else if (typeof initialData.details === 'object') {
//                 setDetails(Object.entries(initialData.details).map(([label, value]) => ({ label, value })));
//             }
//         } else {
//             setDetails([
//                 { label: 'City', value: initialData.city || '' },
//                 { label: 'State', value: initialData.state || '' },
//                 { label: 'mobileNo', value: initialData.mobileNo || '' },
//                 { label: 'Email', value: initialData.emailId || '' },
//                 { label: 'ContactPerson', value: initialData.contactPerson || '' },
//                 { label: 'GST No.', value: initialData.gstNumber || '' }
//             ]);
//         }

//         setSelectedLeadSource(initialData.selectedLeadSource || null);
//         setSelectedEmployee(initialData.selectedEmployee || null);
//         setSelectedActivity(initialData.selectedActivity || null);
//         setSelectedStatus(initialData.selectedStatus || null);

//         if (mode === 'edit') {
//             const inquiryDate = initialData.inquiryDate || initialData.qoutationDate;
//             setqoutationDate(inquiryDate && dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().startOf('day'));
//             setquotationNumber(initialData.quotationNumber || '');
//         }

//         // âœ… ADD THIS FOR REF MODE
//         if (mode === 'ref') {
//             const inquiryDate = initialData.inquiryDate || initialData.quotationNumber;
//             setqoutationDate(inquiryDate && dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().startOf('day'));
//             setquotationNumber(initialData.quotationNumber || '');
//         }

//         if (mode !== 'add') {
//             setReferenceNumber(initialData.referenceNumber || '');
//             const refDateValue = initialData.referenceDate || initialData.RefDate;
//             setReferenceDate(refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : null);
//         }

//         if (mode === "ref") {
//             setReferenceNumber(initialData.quotationNumber || '');
//         }

//         setExchangeRate(initialData.exchangeRate || '');
//         setqnextFollowUpDate(initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().add(7, 'day').startOf('day'));
//         setKindAttend(initialData.kindAttend || '');
//         setProject(initialData.project || '');
//         setAgentName(initialData.AgentName || initialData.agentName || '');
//         setAgentCommission(initialData.AgentComm || initialData.agentCommission || '');
//         setRemark(initialData.remark || initialData.remarks || '');
//         setTransactionType(
//             initialData.transactionType || ""
//         );
//     }, [initialData, mode]);

//     // â”€â”€â”€ Next button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//     const handleNext = () => {
//         if (mode === 'add') {
//             if (!companyName) {
//                 setError('Party Name is required.');
//                 return;
//             }
//             if (!selectedClientId) {
//                 setClientError(true);
//                 return;
//             }
//             // if (!selectedAccount) {
//             //     setError('Account is required.');
//             //     return;
//             // }
//         }
//         if (!companyName && !quotationNumber) {
//             setError('Party & Invoice No. are required.');
//             return;
//         }
//         if (qnextFollowUpDate && qoutationDate && dayjs(qnextFollowUpDate).startOf('day').isBefore(dayjs(qoutationDate).startOf('day'))) {
//             console.log({ qnextFollowUpDate, qoutationDate, qnextFollowUpDate })
//             // setError('Next follow-up must be after invoice date.');
//             // return;
//         }
//         setError('');
//         onNext({
//             clientId: selectedClientId,
//             companyName,
//             quotationNumber,
//             inquiryDate: qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : '',
//             referenceNumber,
//             referenceDate: referenceDate ? dayjs(referenceDate).format('DD/MM/YYYY') : '',
//             RefDate: referenceDate ? dayjs(referenceDate).format('YYYY-MM-DD') : '',
//             agentName,
//             agentCommission: agentCommission || 0,
//             currencyId: selectedCurrency ? selectedCurrency.id : null,
//             exchangeRate: exchangeRate || 0,
//             kindAttend,
//             remarks: remark,
//             project,
//             selectedEmployee,
//             selectedLeadSource,
//             selectedActivity,
//             selectedStatus,
//             AccountId: selectedAccount ? selectedAccount.id : 0,
//             AccountName: selectedAccount ? selectedAccount.label : null,
//             transactionType,
//             details: details.reduce((acc, curr) => {
//                 acc[curr.label] = curr.value;
//                 return acc;
//             }, {})
//         });
//     };

//     // Allow editing only in 'add' or 'edit' modes, but allow date fields in 'ref' mode
//     const isEditable = mode === 'add' || mode === 'edit';
//     const isDateEditable = mode === 'add' || mode === 'edit' || mode === 'ref';

//     return (
//         <Paper elevation={2} sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
//             <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
//                 <Box sx={{ width: { xs: "100%", md: "calc(50% - 16px)" }, pr: { md: 3 } }}>
//                     {/* Party dropdown */}
//                     <Box ref={partyDropdownRef} tabIndex={-1} sx={{ position: 'relative', flex: '1 1 40%' }}
//                         onBlur={e => {
//                             if (!partyDropdownRef.current.contains(e.relatedTarget)) {
//                                 setDropdownOpen(false);
//                             }
//                         }}
//                     >
//                         <TextField disabled={!isEditable || disablePartyName} fullWidth size="small" label="Party Name" variant="outlined" value={toProperCase(companyName)} required InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: '40px', display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }}
//                             onChange={e => {
//                                 setCompanyName(toProperCase(e.target.value));
//                                 setDropdownOpen(true);
//                                 setSelectedClientId(null);   //  invalidate
//                                 setClientError(false);
//                             }}
//                             onBlur={() => {
//                                 if (companyName && !selectedClientId) {
//                                     setClientError(true);
//                                 }
//                             }}
//                             error={clientError}
//                             helperText={
//                                 clientError
//                                     ? "Please select a client from the list"
//                                     : ""
//                             }
//                         />
//                         {/* {dropdownOpen && (
//                             <TableContainer component={Paper} elevation={0} sx={{ mt: 1, maxHeight: 240, position: 'absolute', width: '120%', zIndex: 10, border: 'none', overflow: 'auto', border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1 }}>
//                                 <Table
//                                     size="small"
//                                     sx={{
//                                         borderCollapse: 'separate',
//                                         borderSpacing: 0,
//                                         tableLayout: 'fixed',              // force cells to obey widths
//                                         '& thead th': {
//                                             backgroundColor: '#1877F2',
//                                             color: '#fff',
//                                             fontWeight: 600,
//                                             fontSize: '0.75rem',
//                                             border: 'none'
//                                         },
//                                         '& th, & td': {                    // reduce padding between columns
//                                             padding: '4px 6px',              // smaller vertical & horizontal padding
//                                             fontSize: '0.75rem',
//                                             overflow: 'hidden',
//                                             textOverflow: 'ellipsis',
//                                             whiteSpace: 'nowrap',
//                                         },
//                                         // option: collapse borders so there is no extra gap
//                                         '& .MuiTableCell-root': {
//                                             borderRight: '0px'               // remove right cell border if any
//                                         }
//                                     }}
//                                 >
//                                     <TableHead>
//                                         <TableRow>
//                                             <TableCell sx={{ width: '30%', maxWidth: 200 }}>Company</TableCell>
//                                             <TableCell sx={{ width: '15%', maxWidth: 120 }}>GST No</TableCell>
//                                             <TableCell sx={{ width: '20%', maxWidth: 140 }}>Contact</TableCell>
//                                             <TableCell sx={{ width: '20%', maxWidth: 120 }}>Mobile</TableCell>
//                                             <TableCell sx={{ width: '15%', maxWidth: 100 }}>City</TableCell>
//                                         </TableRow>
//                                     </TableHead>
//                                     <TableBody sx={{ '& > tr:last-of-type': { borderBottom: '1px solid rgba(0,0,0,0.12)' } }}>
//                                         {searchResults.length > 0 ? (
//                                             searchResults.map((r, i) => (
//                                                 <TableRow key={i} hover onMouseDown={() => onSelectResult(r)} sx={{ cursor: 'pointer', backgroundColor: i % 2 === 0 ? '#fff' : 'rgba(227, 242, 253, 1)', border: 'none' }}>
//                                                     <TableCell sx={{ width: '30%', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.FirmName}</TableCell>
//                                                     <TableCell sx={{ width: '15%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.GSTNo}</TableCell>
//                                                     <TableCell sx={{ width: '20%', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.ContactPerson}</TableCell>
//                                                     <TableCell sx={{ width: '20%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.MobileNo}</TableCell>
//                                                     <TableCell sx={{ width: '15%', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.City}</TableCell>
//                                                 </TableRow>
//                                             ))
//                                         ) : (
//                                             <TableRow>
//                                                 <TableCell colSpan={5} align="center">No Data Available</TableCell>
//                                             </TableRow>
//                                         )}
//                                     </TableBody>
//                                     <TableFooter sx={{ borderTop: '1px solid rgba(0,0,0,0.12)' }}>
//                                         <TableRow hover sx={{ cursor: 'pointer', backgroundColor: '#fff' }} onMouseDown={() => setOpenClientPopup(true)}>
//                                             <TableCell colSpan={5} sx={{ textAlign: 'center', color: 'primary.main' }}>
//                                                 âž• Add New Client
//                                             </TableCell>
//                                         </TableRow>
//                                     </TableFooter>
//                                 </Table>
//                             </TableContainer>
//                         )} */}
//                         {dropdownOpen && companyName && (
//                             <Paper
//                                 elevation={0}
//                                 sx={{
//                                     mt: 1,
//                                     position: 'absolute',
//                                     width: { xs: '100%', lg: '800px' },
//                                     zIndex: 10,
//                                     border: '1px solid rgba(0,0,0,0.2)',
//                                     borderRadius: 1,
//                                     maxHeight: 240,
//                                     overflowY: 'auto'
//                                 }}
//                             >
//                                 {isSmallScreen ? (
//                                     /* ===================== CARD VIEW (SM / XS) ===================== */
//                                     <>
//                                         {searchResults.length > 0 ? (
//                                             searchResults.map((r, i) => (
//                                                 <Box
//                                                     key={i}
//                                                     sx={{
//                                                         p: 1.2,
//                                                         borderBottom: '1px solid #eee',
//                                                         cursor: 'pointer'
//                                                     }}
//                                                     onMouseDown={() => {
//                                                         onSelectResult(r);
//                                                         setCompanyName(toProperCase(r.FirmName));
//                                                         setClientError(false);
//                                                         setDropdownOpen(false);
//                                                     }}
//                                                 >
//                                                     <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
//                                                         {toProperCase(r.FirmName)}
//                                                     </Box>

//                                                     <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                                                         GST: {r.GSTNo || '-'}
//                                                     </Box>

//                                                     <Box sx={{ fontSize: '0.75rem' }}>
//                                                         {toProperCase(r.ContactPerson) || '-'} â€¢ {r.MobileNo || '-'}
//                                                     </Box>

//                                                     <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
//                                                         {toProperCase(r.City) || '-'}
//                                                     </Box>
//                                                 </Box>
//                                             ))
//                                         ) : (
//                                             <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
//                                                 Client not found
//                                             </Box>
//                                         )}

//                                         {/* Sticky Add New Client */}
//                                         <Box
//                                             sx={{
//                                                 position: 'sticky',
//                                                 bottom: 0,
//                                                 backgroundColor: '#fff',
//                                                 textAlign: 'center',
//                                                 p: 1,
//                                                 fontWeight: 600,
//                                                 color: 'primary.main',
//                                                 cursor: 'pointer',
//                                                 boxShadow: '0 -2px 6px rgba(0,0,0,0.08)'
//                                             }}
//                                             onMouseDown={() => setOpenClientPopup(true)}
//                                         >
//                                             âž• Add New Client
//                                         </Box>
//                                     </>
//                                 ) : (
//                                     /* ===================== TABLE VIEW (MD / LG) ===================== */
//                                     <Table size="small" stickyHeader>
//                                         <TableHead>
//                                             <TableRow>
//                                                 {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
//                                                     <TableCell
//                                                         key={h}
//                                                         sx={{
//                                                             backgroundColor: '#E0E0E0',
//                                                             fontWeight: 600,
//                                                             fontSize: '0.75rem',
//                                                             position: 'sticky',
//                                                             top: 0,
//                                                             zIndex: 1
//                                                         }}
//                                                     >
//                                                         {h}
//                                                     </TableCell>
//                                                 ))}
//                                             </TableRow>
//                                         </TableHead>

//                                         <TableBody>
//                                             {searchResults.length > 0 ? (
//                                                 searchResults.map((r, i) => (
//                                                     <TableRow
//                                                         key={i}
//                                                         hover
//                                                         sx={{ cursor: 'pointer' }}
//                                                         onMouseDown={() => {
//                                                             onSelectResult(r);
//                                                             setCompanyName(toProperCase(r.FirmName));
//                                                             setClientError(false);
//                                                             setDropdownOpen(false);
//                                                         }}
//                                                     >
//                                                         <TableCell>{toProperCase(r.FirmName)}</TableCell>
//                                                         <TableCell>{r.GSTNo}</TableCell>
//                                                         <TableCell>{toProperCase(r.ContactPerson)}</TableCell>
//                                                         <TableCell>{r.MobileNo}</TableCell>
//                                                         <TableCell>{toProperCase(r.City)}</TableCell>
//                                                     </TableRow>
//                                                 ))
//                                             ) : (
//                                                 <TableRow>
//                                                     <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
//                                                         Client not found
//                                                     </TableCell>
//                                                 </TableRow>
//                                             )}
//                                         </TableBody>

//                                         <TableFooter
//                                             sx={{
//                                                 position: 'sticky',
//                                                 bottom: 0,
//                                                 backgroundColor: '#fff'
//                                             }}
//                                         >
//                                             <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
//                                                 <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
//                                                     âž• Add New Client
//                                                 </TableCell>
//                                             </TableRow>
//                                         </TableFooter>
//                                     </Table>
//                                 )}
//                             </Paper>
//                         )}
//                     </Box>

//                     {/* Details display */}
//                     <Grid item xs={12} md={4} pt={2}>
//                         <TextField fullWidth size="small" label="Address" variant="outlined" disabled value={
//                             Array.isArray(details)
//                                 ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', '))
//                                 : ''
//                         } multiline rows={3} InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }} sx={{ '& .MuiOutlinedInput-root': { display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} />
//                     </Grid>

//                     {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" label="Kind Attend" value={kindAttend} onChange={e => setKindAttend(e.target.value)} InputLabelProps={{ shrink: Boolean(kindAttend) }} sx={{ '& .MuiOutlinedInput-root': { height:38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" label="Project" value={project} onChange={e => setProject(e.target.value)} InputLabelProps={{ shrink: Boolean(project) }} sx={{ '& .MuiOutlinedInput-root': { height:38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
//                         </Box>
//                     </Box> */}

//                     <Box sx={{ mt: 2 }}>
//                         <TextField fullWidth size="small" label="Remark" disabled={!isEditable} multiline minRows={1} maxRows={6} value={remark} InputLabelProps={{ shrink: Boolean(remark) }} inputProps={{ maxLength: 250 }}
//                             onChange={(e) => {
//                                 const val = e.target.value;
//                                 if (val.length <= 250) setRemark(val);
//                                 else setRemark(val.slice(0, 250));
//                             }}
//                             sx={{ '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' } }}
//                         />
//                         <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
//                             {remark.length}/250
//                         </Typography>
//                     </Box>
//                 </Box>

//                 <Box sx={{ width: { xs: "100%", md: "calc(50% - 46px)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
//                     <Box display="flex" gap={2} flex="1 1 40%">
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" label="Invoice No." variant="outlined" value={quotationNumber} disabled InputLabelProps={{ shrink: true }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker label="Invoice Date" value={qoutationDate} onChange={(val) => setqoutationDate(val ? dayjs(val).startOf('day') : null)}
//                                     slots={{
//                                         textField: (params) => (
//                                             <TextField {...params} size="small" fullWidth variant="outlined" value={qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} InputLabelProps={{ shrink: true }} />
//                                         )
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box>
//                     </Box>

//                     {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth size="small" variant="outlined" label="Ref. No." value={referenceNumber} onChange={e => setReferenceNumber(e.target.value)} InputLabelProps={{ shrink: Boolean(referenceNumber) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
//                                 <DatePicker label="Ref. Date" value={referenceDate} onChange={(newValue) => setReferenceDate(newValue ? dayjs(newValue).startOf('day') : null)} disabled={!isDateEditable}
//                                     slots={{
//                                         textField: (params) => (
//                                             <TextField {...params} fullWidth size="small" variant="outlined" value={referenceDate ? referenceDate.format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: Boolean(referenceDate) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
//                                         )
//                                     }}
//                                 />
//                             </LocalizationProvider>
//                         </Box>
//                     </Box> */}

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2} flexDirection={{ xs: 'column', md: 'row' }}>
//                         <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
//                             <Box sx={{ flex: '0 0 50%' }}>
//                                 {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency, openCurrencyPopup, setOpenCurrencyPopup)}
//                             </Box>
//                             <Box sx={{ flex: '0 0 47%' }}>
//                                 <TextField fullWidth size="small" type="number" variant="outlined" label="Ex Rate" value={exchangeRate} InputLabelProps={{ shrink: Boolean(exchangeRate) }}
//                                     onChange={(e) => {
//                                         const value = e.target.value;
//                                         if (/^\d*\.?\d{0,2}$/.test(value)) {
//                                             setExchangeRate(value);
//                                         }
//                                     }}
//                                     sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
//                                 />
//                             </Box>
//                         </Box>

//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <FormControl fullWidth size="small" required sx={{
//                                 '& .MuiFormLabel-asterisk': {
//                                     color: 'red',
//                                 },
//                             }} error={touchedTxnType && !transactionType} >
//                                 <InputLabel>Transaction Type</InputLabel>
//                                 <Select
//                                     value={transactionType}
//                                     label="Transaction Type"
//                                     onChange={(e) => {
//                                         setTransactionType(e.target.value);
//                                         setTouchedTxnType(true);
//                                     }}
//                                     onBlur={() => setTouchedTxnType(true)}
//                                     sx={{ height: 38 }}
//                                     required
//                                 >
//                                     <MenuItem value="regular">Regular</MenuItem>
//                                     <MenuItem value="unregisteredPersons">Unregistered Persons</MenuItem>
//                                     <MenuItem value="sezExempted">SEZ Exempted</MenuItem>
//                                     <MenuItem value="sezTaxPay">SEZ Tax Pay</MenuItem>
//                                     <MenuItem value="exportWithTaxPay">Export With Tax Pay</MenuItem>
//                                     <MenuItem value="exportWithoutTaxPay">Export Without Tax Pay</MenuItem>
//                                     <MenuItem value="exemptedSupplies">Exempted Supplies</MenuItem>
//                                     <MenuItem value="nilRateSupplies">Nil Rate Supplies</MenuItem>
//                                     <MenuItem value="nonGSTSupplies">Non GST Supplies</MenuItem>
//                                     <MenuItem value="compositeSupplier">Composite Supplier</MenuItem>
//                                     <MenuItem value="uinholders">UIN holders</MenuItem>
//                                     <MenuItem value="zeroRatedSupplies">Zero Rated Supplies</MenuItem>
//                                 </Select>
//                             </FormControl>

//                         </Box>
//                     </Box>

//                     <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth label="Agent Name" value={toProperCase(agentName)} onChange={e => setAgentName(toProperCase(e.target.value))} InputLabelProps={{ shrink: Boolean(agentName) }} variant="outlined" size="small" sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }} />
//                         </Box>
//                         <Box sx={{ flex: '0 0 48%' }}>
//                             <TextField fullWidth label="Agent Commission (%)" value={agentCommission} InputLabelProps={{ shrink: Boolean(agentCommission) }} variant="outlined" size="small" type="number"
//                                 onChange={e => {
//                                     const v = e.target.value;
//                                     if (v === '') {
//                                         setAgentCommission('');
//                                         return;
//                                     }
//                                     const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
//                                     if (re.test(v)) {
//                                         setAgentCommission(v);
//                                     }
//                                 }}
//                                 sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }}
//                             />
//                         </Box>
//                     </Box>

//                     <Box sx={{ flex: '0 0 48%' }} pt={2}>
//                         {/* {dropdownField('Account', accountOptions, selectedAccount, setSelectedAccount, openClientPopup, setOpenClientPopup, true)} */}
//                     </Box>
//                 </Box>
//             </Box>

//             {!!error && <Typography color="error" mt={2}>{error}</Typography>}

//             <Box mt={4} display="flex" justifyContent="flex-end">
//                 <Button variant="contained" onClick={handleNext} disabled={!selectedClientId || !isTransactionTypeValid}>Next</Button>
//             </Box>

//             {/* Popups */}
//             <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
//                 if (reason === 'backdropClick') return;
//                 setOpenClientPopup(false);
//             }}>
//                 <DialogContent>
//                     <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
//                 <DialogContent>
//                     <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
//                 <DialogContent>
//                     <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
//                 <DialogContent>
//                     <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
//                 <DialogContent>
//                     <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>
//             <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
//                 <DialogContent>
//                     <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
//                 </DialogContent>
//             </Dialog>

//             <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
//                 <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>
//         </Paper>
//     );
// }







import { useState, useEffect, useRef } from 'react';
import { Box, Paper, Grid, TextField, Autocomplete, Typography, Button, Dialog, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, Snackbar, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import axios from 'axios';
import ClientMaster from '../../ClientMaster';
import LeadSourceMaster from './LeadSourceMaster';
import ActivityMaster from './ActivityMaster';
import CurrencyMaster from '../../CurrencyMaster';
import LeadStatusMaster from './LeadStatusMaster';
import UserMaster from '../../UserMaster';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useAuth } from '../../../context/AuthContext';
import { useConfigure } from '../../../context/ConfigureContext';
import { useTheme, useMediaQuery } from '@mui/material';
import { toProperCase } from '../../../utils/formatRows';
import { getFinancialYearBounds } from '../../../utils/financialYear';
import customParseFormat from "dayjs/plugin/customParseFormat";
import 'dayjs/locale/en-gb';


const transform = (data, idKey, valKey) => data.map(item => ({ id: item[idKey], label: item[valKey] }));
dayjs.extend(customParseFormat);
dayjs.locale('en-gb');


export default function ClientDetails({ initialData = {}, onNext, mode, connectionString, disablePartyName = false }) {

    // DEBUG: Log incoming initialData for edit mode
    if (mode === 'edit') {
        console.log('✅ ClientDetails received initialData:', {
            creditNoteNo: initialData.creditNoteNo,
            creditNoteDate: initialData.creditNoteDate,
            allKeys: Object.keys(initialData)
        });
    }

    const { user, selectedCompany, loading } = useAuth();
    const { isFeatureEnabled } = useConfigure();
    const showCurrency = isFeatureEnabled('Show Currency?');
    const API = connectionString;
    const partyDropdownRef = useRef(null);

    const userId = user?.UserId || null;
    const companyId = selectedCompany?.CompId || null;
    const userCategory = user?.UserCategory || null;
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    // â”€â”€â”€ client search state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [companyName, setCompanyName] = useState(initialData.companyName || '');
    const [selectedClientId, setSelectedClientId] = useState(initialData.clientId || null);
    const [searchResults, setSearchResults] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(0);
    const [clientError, setClientError] = useState(false);


    const [transactionType, setTransactionType] = useState(initialData.transactionType || '')
    const isTransactionTypeValid = Boolean(transactionType);
    const [touchedTxnType, setTouchedTxnType] = useState(false);
    const [selectedGSTNum, setSelectedGSTNum] = useState("")
    const [paymentDays, setPaymentDays] = useState(0);


    const parseDueDate = (value) => {
        if (!value) return dayjs();

        // YYYY-MM-DD (from parent)
        if (value.includes("-")) {
            return dayjs(value);
        }

        // DD/MM/YYYY (from backend)
        return dayjs(value, "DD/MM/YYYY");
    };

    const [dueDate, setdueDate] = useState(() =>
        parseDueDate(initialData.dueDate)
    );
    // Due Days: prefilled from the client's Payment Days, editable; Due Date is calculated from it
    const [dueDays, setDueDays] = useState(() =>
        initialData.dueDays != null && initialData.dueDays !== '' ? String(initialData.dueDays) : ''
    );

    // â”€â”€â”€ CreditNoteNo and CreditNoteDate (user-entered) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [creditNoteNo, setCreditNoteNo] = useState(initialData.creditNoteNo || initialData.CreditNoteNo || '');
    const { startDate, endDate } = getFinancialYearBounds();
    const [creditNoteDate, setCreditNoteDate] = useState(() => {
        const dateValue = initialData.creditNoteDate || initialData.CreditNoteDate;
        if (dateValue && dayjs(dateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
            return dayjs(dateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
        }
        if (mode === 'add' || mode === 'ref') return dayjs().startOf('day');
        return null;
    });

    // â”€â”€â”€ other form state â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [details, setDetails] = useState(initialData.details || []);
    const [error, setError] = useState('');
    const [quotationNumber, setquotationNumber] = useState(initialData.quotationNumber || '');
    const [qoutationDate, setqoutationDate] = useState(() => {
        if (mode === 'add' || mode === 'ref') return dayjs().startOf('day');
        if (initialData.inquiryDate && dayjs(initialData.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
            return dayjs(initialData.inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
        }
        if (initialData.qoutationDate && dayjs(initialData.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
            return dayjs(initialData.qoutationDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
        }
        return null;
    });
    const [referenceNumber, setReferenceNumber] = useState(initialData.referenceNumber || '');
    const [referenceDate, setReferenceDate] = useState(() => {
        const refDateValue = initialData.referenceDate || initialData.RefDate;
        return refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : null;
    });
    const [exchangeRate, setExchangeRate] = useState(initialData.exchangeRate || '');
    const [qnextFollowUpDate, setqnextFollowUpDate] = useState(() => {
        return initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().add(7, 'day').startOf('day');
    });
    const [kindAttend, setKindAttend] = useState(initialData.kindAttend || '');
    const [project, setProject] = useState(initialData.project || '');
    const [agentName, setAgentName] = useState(initialData.agentName || initialData.AgentName || '');
    const [agentCommission, setAgentCommission] = useState(initialData.AgentComm || initialData.agentCommission || '');
    const [remark, setRemark] = useState(initialData.remark || initialData.remarks || '');

    // â”€â”€â”€ masters & popups â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const [currencyOptions, setCurrencyOptions] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(initialData.selectedCurrency || null);
    const [selectedLeadSource, setSelectedLeadSource] = useState(initialData.selectedLeadSource || null);
    const [selectedEmployee, setSelectedEmployee] = useState(initialData.selectedEmployee || null);
    const [selectedActivity, setSelectedActivity] = useState(initialData.selectedActivity || null);
    const [selectedStatus, setSelectedStatus] = useState(initialData.selectedStatus || null);
    const [accountOptions, setAccountOptions] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState(null);

    const [openClientPopup, setOpenClientPopup] = useState(false);
    const [openCurrencyPopup, setOpenCurrencyPopup] = useState(false);
    const [openLeadSourcePopup, setOpenLeadSourcePopup] = useState(false);
    const [openEmployeePopup, setOpenEmployeePopup] = useState(false);
    const [openActivityPopup, setOpenActivityPopup] = useState(false);
    const [openStatusPopup, setOpenStatusPopup] = useState(false);
    const [seriesOptions, setSeriesOptions] = useState([]);
    const [selectedSeries, setSelectedSeries] = useState(initialData.selectedSeries || null);
    const [seriesError, setSeriesError] = useState(false);
    const [BookName, setBookName] = useState('Credit Note');
    const [purcAC, setPurcAC] = useState(initialData.purcAC || initialData.purcACName || '');
    const [selectedPurcACId, setSelectedPurcACId] = useState(initialData.purcACId || initialData.PurcAcId || null);
    const [purcACResults, setPurcACResults] = useState([]);
    const [purcACDropdownOpen, setPurcACDropdownOpen] = useState(false);
    const purcACDropdownRef = useRef(null);
    const [invoiceNumber, setInvoiceNumber] = useState(() => {
        if (mode === 'ref') {
            return initialData.quotationNumber || initialData.InvoiceNumber || '';
        }
        if (mode === 'edit') {
            return initialData.invoiceNumber ||
                initialData.InvoiceNumber ||
                initialData.referenceNumber ||
                '';
        }
        return initialData.invoiceNumber || initialData.InvoiceNumber || '';
    });
    const [invoiceError, setInvoiceError] = useState('');

    // ──── Function to check CreditNoteNo duplication ────
    const checkCreditNoteDuplication = async (creditNoteValue) => {
        if (!creditNoteValue || !selectedClientId || !companyId) {
            return;
        }

        try {
            console.log('🔍 Checking CreditNoteNo duplication:', {
                creditNoteValue,
                companyId,
                selectedClientId,
                purcInvoiceId: initialData?.purcInvoiceId,
                mode
            });
            console.log('📦 initialData keys:', Object.keys(initialData || {}));
            console.log('📦 initialData:', initialData);
            const res = await axios.get(`${API}/api/check-invoice-exists`, {
                params: {
                    CreditNoteNumber: creditNoteValue,
                    CompID: companyId,
                    PartyId: selectedClientId,
                    BookName: 'CRNT',
                    purcInvoiceId: initialData?.purcInvoiceId || null
                }
            });

            if (res.data.exists) {
                setInvoiceError('Credit Note Number already exists for this client');
            } else {
                setInvoiceError('');
            }
        } catch (err) {
            console.error('Error checking credit note:', err);
            setInvoiceError('Error validating Credit Note Number');
        }
    };

    const [invoiceDate, setInvoiceDate] = useState(() => {
        let invDate;

        if (mode === 'ref') {
            invDate = initialData.invoiceDate || initialData.InvoiceDate || initialData.nextFollowUpDate;
        } else if (mode === 'edit') {
            invDate = initialData.referenceDate || initialData.RefDate;
        } else {
            invDate = initialData.invoiceDate || initialData.InvoiceDate;
        }

        if (invDate && dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
            return dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
        }

        return null;
    });


    const [termsOptions, setTermsOptions] = useState([]);
    const [selectedTerms, setSelectedTerms] = useState(initialData.selectedTerms || null);
    const [termsInputValue, setTermsInputValue] = useState('');



    const fetchLastTerms = async () => {
        try {
            const res = await axios.get(`${API}/api/last-terms-type`, {
                params: {
                    mode: 'CreditNote',
                    companyId
                }
            });

            const termsValue = res?.data?.TermsType;

            console.log("modeee", mode)

            // Only for add/ref mode
            if (
                termsValue &&
                (mode === 'add' || mode === 'ref')
            ) {
                setSelectedTerms({
                    label: String(termsValue)
                });
            }

        } catch (err) {
            console.error("Error fetching last terms", err);
        }
    };

    useEffect(() => {
        const fetchTerms = async () => {
            try {
                const { data: response } = await axios.get(`${API}/api/termscondition/search`, {
                    params: { companyId, mode: 'search' },
                    validateStatus: (status) => status >= 200 && status < 400,
                });
                const data = Array.isArray(response?.data) ? response.data : Array.isArray(response) ? response : [];
                console.log(data)
                const options = data.map(item => ({
                    label: item.TermsType || item.TermsName || ''
                }));
                setTermsOptions(options);
            } catch (err) {
                console.error('Error fetching terms:', err);
                setTermsOptions([]);
            }
        };

        if (companyId) {
            fetchTerms();
            fetchLastTerms();
        }


    }, [companyId]);


    console.log("intialDataaaaaaa", initialData)


    const [poNumber, setPoNumber] = useState(initialData.poNumber || initialData.PONo || '');
    const [poDate, setPoDate] = useState(
        initialData.poDate &&
            dayjs(initialData.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
            ? dayjs(initialData.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
            : null
    );

    const [challanNumber, setChallanNumber] = useState(initialData.challanNumber || initialData.challanNo || '');
    const [challanDate, setChallanDate] = useState(
        initialData.challanDate &&
            dayjs(initialData.challanDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
            ? dayjs(initialData.challanDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
            : null
    );

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success"
    });

    const requiredAsteriskStyle = {
        '& .MuiFormLabel-asterisk': {
            color: 'red',
        },
    };

    const handlePopupClose = (data) => {
        if (data?.success) {
            setSnackbar({
                open: true,
                message: data.message,
                severity: "success"
            });
        }
    };

    // ─── Removed real-time blur checking - now checked only on Next button click ──────────

    useEffect(() => {
        if (mode !== 'add' && mode !== 'ref') return;
        if (!companyId) return;

        const fetchDefaultPurcAC = async () => {
            try {
                const res = await axios.get(`${API}/api/getsalespurchaseclients`, {
                    params: {
                        field: 'FirmName',
                        mode: 'SALE',
                        companyId,
                        limit: 10
                    }
                });

                const data = Array.isArray(res.data.data) ? res.data.data : [];

                if (data.length > 0) {
                    setPurcAC(data[0].FirmName || '');
                    setSelectedPurcACId(data[0].id || null);
                }
            } catch (err) {
                console.error('Error fetching default Purc A/C:', err);
            }
        };

        fetchDefaultPurcAC();
    }, [companyId, mode, API]);

    useEffect(() => {
        if (!purcACDropdownOpen || !purcAC) {
            setPurcACResults([]);
            return;
        }

        const fetchPurcAC = async () => {
            try {
                const res = await axios.get(`${API}/api/getsalespurchaseclients`, {
                    params: {
                        field: 'FirmName',
                        search: purcAC,
                        mode: 'SALE',
                        companyId
                    }
                });

                const data = Array.isArray(res.data.data) ? res.data.data : [];
                setPurcACResults(data);
            } catch (err) {
                console.error('Error fetching Purc A/C results:', err);
                setPurcACResults([]);
            }
        };

        fetchPurcAC();
    }, [purcAC, purcACDropdownOpen, companyId, API]);

    useEffect(() => {
        const fetchSeries = async () => {
            try {
                const { data } = await axios.get(`${API}/api/bookmaster-series`, {
                    params: { companyId, bookTypeName: 'Credit Note' }
                });

                const seriesOpts = transform(data, 'BookMastID', 'SeriesName');
                setSeriesOptions(seriesOpts);

            } catch (err) {
                console.error('Error fetching series:', err);
            }
        };

        if (companyId) {
            fetchSeries();
        }
    }, [companyId]);

    useEffect(() => {
        const fetchDefaultSeries = async () => {
            try {
                const { data: response } = await axios.get(`${API}/api/series/getSeries`, {
                    params: {
                        companyId,
                        mode: 'search',
                        bookName: 'Credit Note'   // âœ… ADD THIS
                    }
                });

                const data = response?.data || response || [];

                const defaultSeries = data.find(item => item.IsDefault == 1);

                const isAddOrProforma = mode?.toLowerCase() === 'add' || mode?.toLowerCase() === 'ref';

                console.log("Default Series Data:", data);

                if (defaultSeries && isAddOrProforma && !selectedSeries) {
                    setSelectedSeries({
                        id: defaultSeries.BookMastID,
                        label: defaultSeries.SeriesName
                    });
                }

            } catch (err) {
                console.error("Default Series Error:", err);
            }
        };

        if (companyId && (mode?.toLowerCase() === 'add' || mode?.toLowerCase() === 'ref')) {
            fetchDefaultSeries();
        }
    }, [companyId, mode, BookName]);

    useEffect(() => {
        if (!selectedSeries || mode === 'edit') return;

        const generateNumber = async () => {
            try {
                const { data } = await axios.get(`${API}/api/generate-creditnote-series-number`, {
                    params: { companyId, bookMastId: selectedSeries.id }
                });

                setquotationNumber(data.invoiceNumber);
                setCreditNoteNo(data.invoiceNumber);

            } catch (err) {
                console.error('Error generating credit note number:', err);
                setSnackbar({
                    open: true,
                    message: 'Failed to generate invoice number',
                    severity: 'error'
                });
            }
        };

        generateNumber();
    }, [selectedSeries, mode]);

    // Sync creditNoteNo and creditNoteDate when initialData changes (edit mode)
    useEffect(() => {
        if (mode === 'edit') {
            const newCreditNoteNo = initialData.creditNoteNo || initialData.CreditNoteNo || '';
            if (newCreditNoteNo !== creditNoteNo) {
                console.log('📝 Syncing creditNoteNo from initialData:', newCreditNoteNo);
                setCreditNoteNo(newCreditNoteNo);
            }

            const dateValue = initialData.creditNoteDate || initialData.CreditNoteDate;
            if (dateValue && dayjs(dateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
                const newDate = dayjs(dateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day');
                if (!creditNoteDate || !newDate.isSame(creditNoteDate)) {
                    console.log('📝 Syncing creditNoteDate from initialData:', newDate.format('YYYY-MM-DD'));
                    setCreditNoteDate(newDate);
                }
            }
        }
    }, [initialData.creditNoteNo, initialData.CreditNoteNo, initialData.creditNoteDate, initialData.CreditNoteDate, mode]);

    useEffect(() => {
        // Do NOT auto-change if user has manually selected
        if (touchedTxnType) return;

        // IMPORTANT: GST not yet evaluated
        if (selectedGSTNum === "") return;

        if (selectedGSTNum) {
            setTransactionType("Regular");  // âœ… Changed
        } else {
            setTransactionType("Unregistered Persons");  // âœ… Changed
        }
    }, [selectedGSTNum, touchedTxnType, mode, initialData.transactionType]);

    // â”€â”€â”€ load master lists â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    useEffect(() => {
        const fetchMasters = async () => {
            try {
                const [cur, acc] = await Promise.all([
                    axios.get(`${API}/currencymaster/search?mode=search`),
                    axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', companyId } })
                ]);
                setCurrencyOptions(transform(cur.data || [], 'CurrencyId', 'CurrencySymbol'));
                setAccountOptions(transform(acc.data.data || [], 'id', 'FirmName'));
            } catch (err) {
                console.error('Error fetching masters:', err);
                setCurrencyOptions([]);
                setAccountOptions([]);
            }
        };
        fetchMasters();
    }, []);

    // â”€â”€â”€ initialize account selection â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    useEffect(() => {
        if (!accountOptions.length || !initialData?.id) {
            setSelectedAccount(null);
            return;
        }
        const found = accountOptions.find(opt => String(opt.id) === String(initialData.id));
        setSelectedAccount(found || null);
    }, [accountOptions, initialData.id]);

    // â”€â”€â”€ initialize currency selection â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    useEffect(() => {
        if (!currencyOptions.length || !initialData?.currencyId) {
            setSelectedCurrency(null);
            return;
        }
        const found = currencyOptions.find(opt => String(opt.id) === String(initialData.currencyId));
        setSelectedCurrency(found || null);
    }, [currencyOptions, initialData.currencyId]);

    // â”€â”€â”€ fetch search results â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    // Debounced 350ms so a fast typist doesn't fire one API call per keystroke —
    // the search still starts automatically as the user types, just waits for a
    // brief pause before actually calling the API.
    useEffect(() => {
        if (!companyName || !dropdownOpen) {
            setSearchResults([]);
            return;
        }
        const timeoutId = setTimeout(() => {
            const fetch = async () => {
                try {
                    const res = await axios.get(`${API}/api/company-search`, { params: { field: 'FirmName', search: companyName, companyId } });
                    setSearchResults(Array.isArray(res.data.data) ? res.data.data : []);
                    setHighlightedIndex(0);
                } catch (err) {
                    console.error('Error fetching company search results:', err);
                    setSearchResults([]);
                }
            };
            fetch();
        }, 350);

        return () => clearTimeout(timeoutId);
    }, [companyName, dropdownOpen]);

    // Auto update Due Date when Invoice Date changes
    useEffect(() => {
        if (!qoutationDate) return;
        console.log("mode", mode)

        // Don't override if edit mode has dueDate
        if (mode === "edit") return;

        const baseDate = dayjs(qoutationDate);

        const dd = Number(dueDays) || 0;
        const due = dd > 0 ? baseDate.add(dd, "day") : baseDate;

        setdueDate(due);

    }, [qoutationDate, paymentDays, dueDays]);

    //set due date in edit mode
    useEffect(() => {
        if (mode === "edit" && initialData?.dueDate) {
            setdueDate(parseDueDate(initialData.dueDate));
            setDueDays(
                initialData.dueDays != null && initialData.dueDays !== ''
                    ? String(initialData.dueDays)
                    : String(Math.max(0, parseDueDate(initialData.dueDate).startOf('day').diff((qoutationDate ? dayjs(qoutationDate) : dayjs()).startOf('day'), 'day')))
            );
        }
    }, [initialData, mode]);

    // â”€â”€â”€ handle row selection in table â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const onSelectResult = r => {
        setSelectedClientId(r.id);
        setSelectedGSTNum(r.GSTNo);
        setTouchedTxnType(false)
        setCompanyName(r.FirmName || r.companyName || '');
        setAgentName(r.AgentName || '');
        setAgentCommission(r.AgentComm || '');
        setDetails([
            { label: 'City', value: r.City || '' },
            { label: 'State', value: r.state || '' },
            { label: 'mobileNo', value: r.MobileNo || '' },
            { label: 'Email', value: r.EmailId || '' },
            { label: 'ContactPerson', value: r.ContactPerson || '' },
            { label: 'GST No.', value: r.GSTNo || '' }
        ]);

        //  Due date logic
        const terms = Number(r.PaymentTerm || r.paymentTerm || 0);
        setPaymentDays(terms);
        const baseDate = qoutationDate ? dayjs(qoutationDate) : dayjs();
        const due = terms > 0 ? baseDate.add(terms, "day") : baseDate;
        setDueDays(String(terms));

        setDropdownOpen(false);
        setClientError(false);
    };

    // â”€â”€â”€ dropdownField with popup support â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const dropdownField = (label, options, value, setValue) => (
        <Grid item xs={12} sm={8} md={12}>
            <Autocomplete
                fullWidth
                options={options}
                getOptionLabel={opt => opt?.label || ''}
                value={value}
                onChange={(_, v) => setValue(v)}
                isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                disabled={!isEditable}
                renderInput={params => (
                    <TextField
                        {...params}
                        label={label}
                        size="small"
                        InputLabelProps={{ shrink: Boolean(value) }}
                        sx={{
                            '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                            '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
                        }}
                    />
                )}
            />
        </Grid>
    );


    // â”€â”€â”€ initialize from initialData â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    // useEffect(() => {
    //     if (!initialData || Object.keys(initialData).length === 0) {
    //         if (mode === 'add' || mode === 'ref') {
    //             setqoutationDate(dayjs().startOf('day'));
    //             setReferenceNumber('');
    //             setReferenceDate(null);
    //         }
    //         return;
    //     }
    //     if (mode === 'add' || mode === 'ref') {
    //         setqoutationDate(dayjs().startOf('day'));
    //     }
    //     setCompanyName(initialData.companyName || '');
    //     setSelectedClientId(initialData.clientId ?? null);
    //     if (initialData.details) {
    //         if (Array.isArray(initialData.details)) {
    //             setDetails(initialData.details);
    //         } else if (typeof initialData.details === 'object') {
    //             setDetails(Object.entries(initialData.details).map(([label, value]) => ({ label, value })));
    //         }
    //     } else {
    //         setDetails([
    //             { label: 'City', value: initialData.city || '' },
    //             { label: 'State', value: initialData.state || '' },
    //             { label: 'mobileNo', value: initialData.mobileNo || '' },
    //             { label: 'Email', value: initialData.emailId || '' },
    //             { label: 'ContactPerson', value: initialData.contactPerson || '' },
    //             { label: 'GST No.', value: initialData.gstNumber || '' }
    //         ]);
    //     }
    //     setSelectedLeadSource(initialData.selectedLeadSource || null);
    //     setSelectedEmployee(initialData.selectedEmployee || null);
    //     setSelectedActivity(initialData.selectedActivity || null);
    //     setSelectedStatus(initialData.selectedStatus || null);
    //     if (mode === 'edit') {
    //         const inquiryDate = initialData.inquiryDate || initialData.qoutationDate;
    //         setqoutationDate(inquiryDate && dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().startOf('day'));
    //         setquotationNumber(initialData.quotationNumber || '');
    //     }
    //     if (mode !== 'add') {
    //         setReferenceNumber(initialData.referenceNumber || '');
    //         const refDateValue = initialData.referenceDate || initialData.RefDate;
    //         setReferenceDate(refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : null);
    //     }
    //     if (mode === "ref") {
    //         setReferenceNumber(initialData.quotationNumber || '');
    //     }
    //     setExchangeRate(initialData.exchangeRate || '');
    //     setqnextFollowUpDate(initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().add(7, 'day').startOf('day'));
    //     setKindAttend(initialData.kindAttend || '');
    //     setProject(initialData.project || '');
    //     setAgentName(initialData.AgentName || initialData.agentName || '');
    //     setAgentCommission(initialData.AgentComm || initialData.agentCommission || '');
    //     setRemark(initialData.remark || initialData.remarks || '');
    // }, [initialData, mode]);

    useEffect(() => {
        if (!initialData || Object.keys(initialData).length === 0) {
            if (mode === 'add' || mode === 'ref') {
                setqoutationDate(dayjs().startOf('day'));
                setReferenceNumber('');
                setReferenceDate(null);
            }
            return;
        }

        // âœ… ONLY override date in 'add' mode, NOT in 'ref' mode
        if (mode === 'add') {
            setqoutationDate(dayjs().startOf('day'));
        }

        // Set company name from initialData
        setCompanyName(initialData.companyName || '');

        if (mode === 'edit') {
            setSelectedTerms(
                initialData.TermsType
                    ? {
                        id: initialData.TermsType,
                        label: String(initialData.TermsType)
                    }
                    : null
            );
        }

        // Set clientId from initialData
        setSelectedClientId(initialData.clientId ?? null);

        // Rest of code stays same...
        if (initialData.details) {
            if (Array.isArray(initialData.details)) {
                setDetails(initialData.details);
            } else if (typeof initialData.details === 'object') {
                setDetails(Object.entries(initialData.details).map(([label, value]) => ({ label, value })));
            }
        } else {
            setDetails([
                { label: 'City', value: initialData.city || '' },
                { label: 'State', value: initialData.state || '' },
                { label: 'mobileNo', value: initialData.mobileNo || '' },
                { label: 'Email', value: initialData.emailId || '' },
                { label: 'ContactPerson', value: initialData.contactPerson || '' },
                { label: 'GST No.', value: initialData.gstNumber || '' }
            ]);
        }

        setSelectedLeadSource(initialData.selectedLeadSource || null);
        setSelectedEmployee(initialData.selectedEmployee || null);
        setSelectedActivity(initialData.selectedActivity || null);
        setSelectedStatus(initialData.selectedStatus || null);

        if (mode === 'edit') {
            const inquiryDate = initialData.inquiryDate || initialData.qoutationDate;
            setqoutationDate(inquiryDate && dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(inquiryDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().startOf('day'));
            setquotationNumber(initialData.quotationNumber || '');
        }

        // âœ… ADD THIS FOR REF MODE
        if (mode === 'ref') {
            setqoutationDate(dayjs().startOf('day'));
            setquotationNumber(initialData.quotationNumber || '');
        }

        if (mode !== 'add') {
            setReferenceNumber(initialData.referenceNumber || '');
            const refDateValue = initialData.referenceDate || initialData.RefDate;
            setReferenceDate(refDateValue && dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(refDateValue, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : null);
        }

        if (mode === "ref") {
            setReferenceNumber(initialData.quotationNumber || '');
        }

        setExchangeRate(initialData.exchangeRate || '');
        setqnextFollowUpDate(initialData.nextFollowUpDate && dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid() ? dayjs(initialData.nextFollowUpDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day') : dayjs().add(7, 'day').startOf('day'));
        setKindAttend(initialData.kindAttend || '');
        setProject(initialData.project || '');
        setAgentName(initialData.AgentName || initialData.agentName || '');
        setAgentCommission(initialData.AgentComm || initialData.agentCommission || '');
        setRemark(initialData.remark || initialData.remarks || '');

        setPoNumber(initialData.poNumber || initialData.PONo || '');

        setPoDate(
            initialData.poDate &&
                dayjs(initialData.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
                ? dayjs(initialData.poDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
                : null
        );
        setChallanNumber(initialData.challanNumber || initialData.challanNo || '');

        setChallanDate(
            initialData.challanDate &&
                dayjs(initialData.challanDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()
                ? dayjs(initialData.challanDate, ['DD/MM/YYYY', 'YYYY-MM-DD'])
                : null
        );

        setTransactionType(
            initialData.transactionType || ""
        );



        if (mode === 'edit') {
            setPurcAC(initialData.purcAC || initialData.purcACName || '');
            setSelectedPurcACId(initialData.purcACId || initialData.PurcAcId || null);
        }

        // âœ… SET INVOICE DATA BASED ON MODE
        if (mode === 'ref') {
            setInvoiceNumber(initialData.quotationNumber || initialData.InvoiceNumber || '');

            const invDate = initialData.invoiceDate || initialData.InvoiceDate || initialData.nextFollowUpDate;

            if (invDate && dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
                setInvoiceDate(dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day'));
            } else {
                setInvoiceDate(null);
            }

        } else if (mode === 'edit' && !invoiceNumber) {
            setInvoiceNumber(initialData.referenceNumber || '');

            const refDate = initialData.referenceDate || initialData.RefDate;

            if (refDate && dayjs(refDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
                setInvoiceDate(dayjs(refDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day'));
            } else {
                setInvoiceDate(null);
            }

        }
        else {
            setInvoiceNumber(initialData.invoiceNumber || initialData.InvoiceNumber || '');

            const invDate = initialData.invoiceDate || initialData.InvoiceDate;

            if (invDate && dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).isValid()) {
                setInvoiceDate(dayjs(invDate, ['DD/MM/YYYY', 'YYYY-MM-DD']).startOf('day'));
            } else {
                setInvoiceDate(null);
            }
        }

    }, [initialData, mode]);


    console.log("invoiceNumber", initialData.invoiceNumber)

    // â”€â”€â”€ Next button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const handleNext = async () => {
        if (mode === 'add') {
            if (!companyName) {
                setError('Party Name is required.');
                return;
            }
            if (!selectedClientId) {
                setClientError(true);
                return;
            }
            // if (!selectedAccount) {
            //     setError('Account is required.');
            //     return;
            // }
        }
        if (!companyName && !quotationNumber) {
            setError('Party Name & Credit Note No. are required.');
            return;
        }
        if (mode === 'add' && !selectedSeries) {
            setSeriesError(true);
            return;
        }
        if (!creditNoteNo) {
            setError('Credit Note No. is required.');
            return;
        }

        // Check if there's an existing error from blur validation
        if (invoiceError) {
            setError('Please fix the Credit Note Number error before proceeding');
            return;
        }
        if (qnextFollowUpDate && qoutationDate && dayjs(qnextFollowUpDate).startOf('day').isBefore(dayjs(qoutationDate).startOf('day'))) {
            console.log({ qnextFollowUpDate, qoutationDate, qnextFollowUpDate })
            // setError('Next follow-up must be after invoice date.');
            // return;
        }
        setError('');
        onNext({
            clientId: selectedClientId,
            companyName,
            quotationNumber,
            selectedSeries: selectedSeries, // NEW: Pass series info
            bookMastId: selectedSeries?.id,
            inquiryDate: qoutationDate ? dayjs(qoutationDate).format('DD/MM/YYYY') : '',
            creditNoteNo: creditNoteNo || '',
            creditNoteDate: creditNoteDate ? dayjs(creditNoteDate).format('DD/MM/YYYY') : '',
            invoiceNumber: invoiceNumber || '',
            invoiceDate: invoiceDate
                ? dayjs(invoiceDate).format('DD/MM/YYYY')
                : null,
            referenceNumber,
            referenceDate: referenceDate ? dayjs(referenceDate).format('DD/MM/YYYY') : '',
            RefDate: referenceDate ? dayjs(referenceDate).format('YYYY-MM-DD') : '',
            agentName,
            agentCommission: agentCommission || 0,
            currencyId: selectedCurrency ? selectedCurrency.id : null,
            exchangeRate: exchangeRate || 0,
            kindAttend,
            remarks: remark,
            project,
            selectedEmployee,
            selectedLeadSource,
            selectedActivity,
            selectedStatus,
            AccountId: selectedAccount ? selectedAccount.id : 0,
            AccountName: selectedAccount ? selectedAccount.label : null,
            transactionType,
            dueDate: dueDate ? dayjs(dueDate).format('YYYY-MM-DD') : null,
            dueDays: dueDays === '' ? null : Number(dueDays),
            purcAC,
            purcACId: selectedPurcACId,
            details: details.reduce((acc, curr) => {
                acc[curr.label] = curr.value;
                return acc;
            }, {}),
            poNumber: poNumber || null,
            poDate: poDate && poDate.isValid()
                ? poDate.format('YYYY-MM-DD')
                : null,
            TermsType: selectedTerms?.label || null,
            challanNumber: challanNumber || null,
            challanDate: challanDate && challanDate.isValid() ? challanDate.format('YYYY-MM-DD')
                : null
        });
    };

    // Allow editing only in 'add' or 'edit' modes, but allow date fields in 'ref' mode
    const isEditable = mode === 'add' || mode === 'edit';
    const isDateEditable = mode === 'add' || mode === 'edit' || mode === 'ref';
    const isInvoiceFieldsDisabled = mode === 'edit' && !!initialData?.SIID;

    return (
        <Paper elevation={2} sx={{ p: 1, overflowX: 'hidden', mt: -1.5 }}>
            <Box display="flex" justifyContent="space-between" flexWrap="wrap" pt={1}>
                <Box sx={{ width: { xs: "100%", md: "calc(47% - 20px)" }, pr: { md: 3 } }}>

                    {/* Party dropdown */}
                    <Box ref={partyDropdownRef} tabIndex={-1} sx={{ position: 'relative', flex: '1 1 40%' }}
                        onBlur={e => {
                            if (!partyDropdownRef.current.contains(e.relatedTarget)) {
                                setDropdownOpen(false);
                            }
                        }}
                    >
                        <TextField autoFocus={mode === 'add'} disabled={!isEditable || disablePartyName} fullWidth size="small" label="Party Name" variant="outlined" value={toProperCase(companyName)} required InputLabelProps={{ shrink: Boolean(companyName), sx: requiredAsteriskStyle }} sx={{ '& .MuiOutlinedInput-root': { height: '40px', display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }}
                            onChange={e => {
                                setCompanyName(toProperCase(e.target.value));
                                setDropdownOpen(true);
                                setSelectedClientId(null);   //  invalidate
                                setClientError(false);
                            }}
                            onBlur={() => {
                                if (companyName && !selectedClientId) {
                                    setClientError(true);
                                }
                            }}
                            onKeyDown={(e) => {
                                if (!dropdownOpen || searchResults.length === 0) return;
                                if (e.key === 'ArrowDown') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.min(prev + 1, searchResults.length - 1));
                                } else if (e.key === 'ArrowUp') {
                                    e.preventDefault();
                                    setHighlightedIndex((prev) => Math.max(prev - 1, 0));
                                } else if (e.key === 'Enter') {
                                    e.preventDefault();
                                    const selected = searchResults[highlightedIndex];
                                    if (selected) {
                                        onSelectResult(selected);
                                        setCompanyName(toProperCase(selected.FirmName));
                                        setClientError(false);
                                        setDropdownOpen(false);
                                    }
                                } else if (e.key === 'Escape') {
                                    setDropdownOpen(false);
                                }
                            }}
                            error={clientError}
                            helperText={
                                clientError
                                    ? "Please select a client from the list"
                                    : ""
                            }
                        />
                        {/* {dropdownOpen && (
                            <TableContainer component={Paper} elevation={0} sx={{ mt: 1, maxHeight: 240, position: 'absolute', width: '120%', zIndex: 10, border: 'none', overflow: 'auto', border: '1px solid rgba(0,0,0,0.2)', borderRadius: 1 }}>
                                <Table
                                    size="small"
                                    sx={{
                                        borderCollapse: 'separate',
                                        borderSpacing: 0,
                                        tableLayout: 'fixed',              // force cells to obey widths
                                        '& thead th': {
                                            backgroundColor: '#1877F2',
                                            color: '#fff',
                                            fontWeight: 600,
                                            fontSize: '0.75rem',
                                            border: 'none'
                                        },
                                        '& th, & td': {                    // reduce padding between columns
                                            padding: '4px 6px',              // smaller vertical & horizontal padding
                                            fontSize: '0.75rem',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                        },
                                        // option: collapse borders so there is no extra gap
                                        '& .MuiTableCell-root': {
                                            borderRight: '0px'               // remove right cell border if any
                                        }
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ width: '30%', maxWidth: 200 }}>Company</TableCell>
                                            <TableCell sx={{ width: '15%', maxWidth: 120 }}>GST No</TableCell>
                                            <TableCell sx={{ width: '20%', maxWidth: 140 }}>Contact</TableCell>
                                            <TableCell sx={{ width: '20%', maxWidth: 120 }}>Mobile</TableCell>
                                            <TableCell sx={{ width: '15%', maxWidth: 100 }}>City</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody sx={{ '& > tr:last-of-type': { borderBottom: '1px solid rgba(0,0,0,0.12)' } }}>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <TableRow key={i} hover onMouseDown={() => onSelectResult(r)} sx={{ cursor: 'pointer', backgroundColor: i % 2 === 0 ? '#fff' : 'rgba(227, 242, 253, 1)', border: 'none' }}>
                                                    <TableCell sx={{ width: '30%', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.FirmName}</TableCell>
                                                    <TableCell sx={{ width: '15%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.GSTNo}</TableCell>
                                                    <TableCell sx={{ width: '20%', maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.ContactPerson}</TableCell>
                                                    <TableCell sx={{ width: '20%', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.MobileNo}</TableCell>
                                                    <TableCell sx={{ width: '15%', maxWidth: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{r.City}</TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={5} align="center">No Data Available</TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                    <TableFooter sx={{ borderTop: '1px solid rgba(0,0,0,0.12)' }}>
                                        <TableRow hover sx={{ cursor: 'pointer', backgroundColor: '#fff' }} onMouseDown={() => setOpenClientPopup(true)}>
                                            <TableCell colSpan={5} sx={{ textAlign: 'center', color: 'primary.main' }}>
                                                âž• Add New Client
                                            </TableCell>
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </TableContainer>
                        )} */}
                        {dropdownOpen && companyName && (
                            <Paper
                                elevation={0}
                                sx={{
                                    mt: 1,
                                    position: 'absolute',
                                    width: { xs: '100%', lg: '800px' },
                                    zIndex: 10,
                                    border: '1px solid rgba(0,0,0,0.2)',
                                    borderRadius: 1,
                                    maxHeight: 240,
                                    overflowY: 'auto'
                                }}
                            >
                                {isSmallScreen ? (
                                    /* ===================== CARD VIEW (SM / XS) ===================== */
                                    <>
                                        {searchResults.length > 0 ? (
                                            searchResults.map((r, i) => (
                                                <Box
                                                    key={i}
                                                    sx={{
                                                        p: 1.2,
                                                        borderBottom: '1px solid #eee',
                                                        cursor: 'pointer',
                                                        backgroundColor: i === highlightedIndex ? 'action.selected' : 'transparent'
                                                    }}
                                                    onMouseEnter={() => setHighlightedIndex(i)}
                                                    onMouseDown={() => {
                                                        onSelectResult(r);
                                                        setCompanyName(toProperCase(r.FirmName));
                                                        setClientError(false);
                                                        setDropdownOpen(false);
                                                    }}
                                                >
                                                    <Box sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
                                                        {toProperCase(r.FirmName)}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                                        GST: {r.GSTNo || '-'}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem' }}>
                                                        {toProperCase(r.ContactPerson) || '-'} â€¢ {r.MobileNo || '-'}
                                                    </Box>

                                                    <Box sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                                                        {toProperCase(r.City) || '-'}
                                                    </Box>
                                                </Box>
                                            ))
                                        ) : (
                                            <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
                                                Client not found
                                            </Box>
                                        )}

                                        {/* Sticky Add New Client */}
                                        <Box
                                            sx={{
                                                position: 'sticky',
                                                bottom: 0,
                                                backgroundColor: '#fff',
                                                textAlign: 'center',
                                                p: 1,
                                                fontWeight: 600,
                                                color: 'primary.main',
                                                cursor: 'pointer',
                                                boxShadow: '0 -2px 6px rgba(0,0,0,0.08)'
                                            }}
                                            onMouseDown={() => setOpenClientPopup(true)}
                                        >
                                            âž• Add New Client
                                        </Box>
                                    </>
                                ) : (
                                    /* ===================== TABLE VIEW (MD / LG) ===================== */
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map(h => (
                                                    <TableCell
                                                        key={h}
                                                        sx={{
                                                            backgroundColor: '#E0E0E0',
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1
                                                        }}
                                                    >
                                                        {h}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {searchResults.length > 0 ? (
                                                searchResults.map((r, i) => (
                                                    <TableRow
                                                        key={i}
                                                        hover
                                                        selected={i === highlightedIndex}
                                                        sx={{ cursor: 'pointer' }}
                                                        onMouseEnter={() => setHighlightedIndex(i)}
                                                        onMouseDown={() => {
                                                            onSelectResult(r);
                                                            setCompanyName(toProperCase(r.FirmName));
                                                            setClientError(false);
                                                            setDropdownOpen(false);
                                                        }}
                                                    >
                                                        <TableCell>{toProperCase(r.FirmName)}</TableCell>
                                                        <TableCell>{r.GSTNo}</TableCell>
                                                        <TableCell>{toProperCase(r.ContactPerson)}</TableCell>
                                                        <TableCell>{r.MobileNo}</TableCell>
                                                        <TableCell>{toProperCase(r.City)}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
                                                        Client not found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>

                                        <TableFooter
                                            sx={{
                                                position: 'sticky',
                                                bottom: 0,
                                                backgroundColor: '#fff'
                                            }}
                                        >
                                            <TableRow hover onMouseDown={() => setOpenClientPopup(true)}>
                                                <TableCell colSpan={5} align="center" sx={{ color: 'primary.main', fontWeight: 600 }}>
                                                    âž• Add New Client
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    </Table>
                                )}
                            </Paper>
                        )}
                    </Box>

                    {/* Details display */}
                    <Grid item xs={12} md={4} pt={2}>
                        <TextField fullWidth size="small" label="Address" variant="outlined" disabled value={
                            Array.isArray(details)
                                ? toProperCase(details.map(d => `${d.label}: ${d.value}`).join(', '))
                                : ''
                        } multiline rows={3} InputLabelProps={{ shrink: Array.isArray(details) && details.length > 0 }} sx={{ '& .MuiOutlinedInput-root': { display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} />
                    </Grid>

                    {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Kind Attend" value={kindAttend} onChange={e => setKindAttend(e.target.value)} InputLabelProps={{ shrink: Boolean(kindAttend) }} sx={{ '& .MuiOutlinedInput-root': { height:38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" label="Project" value={project} onChange={e => setProject(e.target.value)} InputLabelProps={{ shrink: Boolean(project) }} sx={{ '& .MuiOutlinedInput-root': { height:38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                        </Box>
                    </Box> */}

                    <Box sx={{ mt: 2 }}>
                        <TextField fullWidth size="small" label="Remark" disabled={!isEditable} multiline minRows={1} maxRows={6} value={remark} InputLabelProps={{ shrink: Boolean(remark) }} inputProps={{ maxLength: 250 }}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val.length <= 250) setRemark(val);
                                else setRemark(val.slice(0, 250));
                            }}
                            sx={{ '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' } }}
                        />
                        <Typography variant="caption" sx={{ display: 'block', mt: 0.5, textAlign: 'right', color: 'text.secondary' }}>
                            {remark.length}/250
                        </Typography>
                    </Box>

                    <Box display="flex" justifyContent="flex-start">
                        <Box
                            ref={purcACDropdownRef}
                            tabIndex={-1}
                            sx={{ flex: 1 }}
                            onBlur={(e) => {
                                if (!purcACDropdownRef.current?.contains(e.relatedTarget)) {
                                    setPurcACDropdownOpen(false);
                                }
                            }}
                        >
                            <TextField
                                fullWidth
                                required
                                label="Sales Return A/C"
                                value={toProperCase(purcAC)}
                                InputLabelProps={{ shrink: Boolean(purcAC) }}
                                variant="outlined"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: '38px' },
                                    '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' },
                                    '& .MuiFormLabel-asterisk': { color: 'red' }
                                }}
                                onChange={(e) => {
                                    setPurcAC(e.target.value);
                                    setPurcACDropdownOpen(true);
                                    setSelectedPurcACId(null);
                                }}
                                onFocus={() => {
                                    if (purcAC) setPurcACDropdownOpen(true);
                                }}
                            />

                            {purcACDropdownOpen && purcAC && (
                                <Paper
                                    elevation={0}
                                    sx={{
                                        mt: 1,
                                        position: 'absolute',
                                        width: { xs: '100%', lg: '500px' },
                                        zIndex: 10,
                                        border: '1px solid rgba(0,0,0,0.2)',
                                        borderRadius: 1,
                                        maxHeight: 240,
                                        overflowY: 'auto'
                                    }}
                                >
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                {['Company', 'GST No', 'Contact', 'Mobile', 'City'].map((h) => (
                                                    <TableCell
                                                        key={h}
                                                        sx={{
                                                            backgroundColor: '#E0E0E0',
                                                            fontWeight: 600,
                                                            fontSize: '0.75rem',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1
                                                        }}
                                                    >
                                                        {h}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>
                                            {purcACResults.length > 0 ? (
                                                purcACResults.map((r, i) => (
                                                    <TableRow
                                                        key={i}
                                                        hover
                                                        sx={{ cursor: 'pointer' }}
                                                        onMouseDown={() => {
                                                            setPurcAC(r.FirmName);
                                                            setSelectedPurcACId(r.id);
                                                            setPurcACDropdownOpen(false);
                                                        }}
                                                    >
                                                        <TableCell>{toProperCase(r.FirmName)}</TableCell>
                                                        <TableCell>{r.GSTNo || '-'}</TableCell>
                                                        <TableCell>{toProperCase(r.ContactPerson) || '-'}</TableCell>
                                                        <TableCell>{r.MobileNo || '-'}</TableCell>
                                                        <TableCell>{toProperCase(r.City) || '-'}</TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={5} align="center" sx={{ color: 'error.main' }}>
                                                        Purc A/C not found
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </Paper>
                            )}
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ width: { xs: "100%", md: "calc(53%)" }, pt: { xs: 2, md: 0 } }} alignSelf="right">
                    <Box display="flex" gap={1} flex="1 1 40%">
                        {(mode === 'add' || mode === 'ref') && (
                            <Box sx={{ flex: '1 1 33.33%' }}>
                                <Autocomplete
                                    fullWidth
                                    size="small"
                                    options={seriesOptions}
                                    getOptionLabel={opt => opt?.label || ''}
                                    value={selectedSeries}
                                    onChange={(_, v) => {
                                        setSelectedSeries(v);
                                        setSeriesError(false);
                                    }}
                                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Select Series"
                                            required
                                            error={seriesError}
                                            helperText={seriesError ? "Please select a series" : ""}
                                            sx={{
                                                '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                                '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' },
                                                '& .MuiFormLabel-asterisk': { color: 'red' }
                                            }}
                                        />
                                    )}
                                />
                            </Box>
                        )}
                        <Box sx={{ flex: '1 1 33.33%' }}>
                            <TextField fullWidth size="small" label="CreditNoteNo" variant="outlined" value={creditNoteNo} onChange={(e) => setCreditNoteNo(e.target.value)} onBlur={() => checkCreditNoteDuplication(creditNoteNo)} placeholder={quotationNumber} required InputLabelProps={{ shrink: Boolean(creditNoteNo), sx: requiredAsteriskStyle }} error={!!invoiceError || (!creditNoteNo && error === 'Credit Note No. is required.')} helperText={invoiceError || ''} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} />
                        </Box>
                        <Box sx={{ flex: '1 1 33.33%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker label="CreditNoteDate" value={creditNoteDate} onChange={(val) => setCreditNoteDate(val ? dayjs(val).startOf('day') : null)} minDate={dayjs(startDate)} maxDate={dayjs(endDate)}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} size="small" fullWidth variant="outlined" sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { padding: '0 12px' } }} InputLabelProps={{ shrink: Boolean(creditNoteDate) }} />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    {/* <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth size="small" variant="outlined" label="Ref. No." value={referenceNumber} onChange={e => setReferenceNumber(e.target.value)} InputLabelProps={{ shrink: Boolean(referenceNumber) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker label="Ref. Date" value={referenceDate} onChange={(newValue) => setReferenceDate(newValue ? dayjs(newValue).startOf('day') : null)} disabled={!isDateEditable}
                                    slots={{
                                        textField: (params) => (
                                            <TextField {...params} fullWidth size="small" variant="outlined" value={referenceDate ? referenceDate.format('DD/MM/YYYY') : ''} InputLabelProps={{ shrink: Boolean(referenceDate) }} sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }} />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box> */}

                    <Box display="flex" gap={1} flex="1 1 40%" mt={1}>
                        {/* Invoice No */}
                        <Box sx={{ flex: '1 1 50%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Invoice No"
                                value={invoiceNumber}
                                onChange={(e) => setInvoiceNumber(e.target.value)}
                                disabled={mode === 'ref' || isInvoiceFieldsDisabled}
                                InputLabelProps={{ shrink: Boolean(invoiceNumber) }}
                                sx={{
                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                    '& .MuiOutlinedInput-input': { padding: '0 12px' }
                                }}
                            />
                        </Box>

                        {/* Invoice Date */}
                        <Box sx={{ flex: '1 1 50%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="Invoice Date"
                                    value={invoiceDate}
                                    onChange={(val) => setInvoiceDate(val ? dayjs(val).startOf('day') : null)}
                                    disabled={mode === 'ref' || isInvoiceFieldsDisabled}
                                    slots={{
                                        textField: (params) => (
                                            <TextField
                                                {...params}
                                                size="small"
                                                fullWidth
                                                variant="outlined"
                                                value={invoiceDate ? dayjs(invoiceDate).format('DD/MM/YYYY') : ''}
                                                InputLabelProps={{ shrink: true }}
                                                sx={{
                                                    '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
                                                    '& .MuiOutlinedInput-input': { padding: '0 12px' }
                                                }}
                                            />
                                        )
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Box>

                    <Box display="flex" gap={1} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 23.5%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="PO No."
                                value={poNumber}
                                onChange={(e) => setPoNumber(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(poNumber) }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: 38,
                                        display: 'flex',
                                        alignItems: 'center'
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        fontSize: '0.875rem',
                                        padding: '0 12px'
                                    }
                                }}
                            />
                        </Box>

                        <Box sx={{ flex: '0 0 24%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="PO Date"
                                    value={poDate}
                                    onChange={(newValue) => setPoDate(newValue)}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: '100%', // ADD THIS
                                        '& .MuiOutlinedInput-root': {
                                            height: 38,
                                            display: 'flex',
                                            alignItems: 'center'
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            fontSize: '0.875rem',
                                            padding: '0 12px'
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true, // ALSO ADD THIS
                                            size: "small",
                                            variant: "outlined",
                                            InputLabelProps: {
                                                shrink: Boolean(poDate)
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>

                        {/* ❌ COMMENTED: Challan No. field */}
                        {/* <Box sx={{ flex: '0 0 23.5%' }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Challan No."
                                value={challanNumber}
                                onChange={(e) => setChallanNumber(e.target.value)}
                                InputLabelProps={{ shrink: Boolean(challanNumber) }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: 38,
                                        display: 'flex',
                                        alignItems: 'center'
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        fontSize: '0.875rem',
                                        padding: '0 12px'
                                    }
                                }}
                            />
                        </Box>

                        {/* ❌ COMMENTED: Challan Dt. field */}
                        {/* <Box sx={{ flex: '0 0 24%' }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="Challan Dt."
                                    value={challanDate}
                                    onChange={(newValue) => setChallanDate(newValue)}
                                    format="DD/MM/YYYY"
                                    sx={{
                                        width: '100%', // ADD THIS
                                        '& .MuiOutlinedInput-root': {
                                            height: 38,
                                            display: 'flex',
                                            alignItems: 'center'
                                        },
                                        '& .MuiOutlinedInput-input': {
                                            fontSize: '0.875rem',
                                            padding: '0 12px'
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true, // ALSO ADD THIS
                                            size: "small",
                                            variant: "outlined",
                                            InputLabelProps: {
                                                shrink: Boolean(challanDate)
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </Box> */}
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2} flexDirection={{ xs: 'column', md: 'row' }}>
                        <Box sx={{ flex: '0 0 48%', display: 'flex', gap: 1, alignItems: 'center' }}>
                            {showCurrency && (
                                <>
                                    <Box sx={{ flex: '0 0 50%' }}>
                                        {dropdownField('Currency', currencyOptions, selectedCurrency, setSelectedCurrency, openCurrencyPopup, setOpenCurrencyPopup)}
                                    </Box>
                                    <Box sx={{ flex: '0 0 47%' }}>
                                        <TextField fullWidth size="small" type="number" variant="outlined" label="Ex Rate" value={exchangeRate} InputLabelProps={{ shrink: Boolean(exchangeRate) }}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                                    setExchangeRate(value);
                                                }
                                            }}
                                            sx={{ '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' } }}
                                        />
                                    </Box>
                                </>
                            )}
                        </Box>



                        <Box sx={{ flex: '0 0 48%' }}>
                            <FormControl fullWidth size="small" required sx={{
                                '& .MuiFormLabel-asterisk': {
                                    color: 'red',
                                },
                            }} error={touchedTxnType && !transactionType} >
                                <InputLabel>Transaction Type</InputLabel>
                                <Select
                                    value={transactionType}
                                    label="Transaction Type"
                                    onChange={(e) => {
                                        setTransactionType(e.target.value);
                                        setTouchedTxnType(true);
                                    }}
                                    onBlur={() => setTouchedTxnType(true)}
                                    sx={{ height: 38 }}
                                    required
                                >
                                    <MenuItem value="Regular">Regular</MenuItem>
                                    <MenuItem value="Unregistered Persons">Unregistered Persons</MenuItem>
                                    <MenuItem value="SEZ Exempted">SEZ Exempted</MenuItem>
                                    <MenuItem value="SEZ Tax Pay">SEZ Tax Pay</MenuItem>
                                    <MenuItem value="Export With Tax Pay">Export With Tax Pay</MenuItem>
                                    <MenuItem value="Export Without Tax Pay">Export Without Tax Pay</MenuItem>
                                    <MenuItem value="Exempted Supplies">Exempted Supplies</MenuItem>
                                    <MenuItem value="Nil Rate Supplies">Nil Rate Supplies</MenuItem>
                                    <MenuItem value="Non GST Supplies">Non GST Supplies</MenuItem>
                                    <MenuItem value="Composite Supplier">Composite Supplier</MenuItem>
                                    <MenuItem value="UIN holders">UIN holders</MenuItem>
                                    <MenuItem value="Import of Goods">Import of Goods</MenuItem>
                                    <MenuItem value="Import of Services">Import of Services</MenuItem>
                                    <MenuItem value="Inward Supplies of ISD">Inward Supplies of ISD</MenuItem>
                                </Select>
                            </FormControl>

                        </Box>
                    </Box>

                    <Box display="flex" gap={2} flex="1 1 40%" pt={2}>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth label="Agent Name" value={toProperCase(agentName)} onChange={e => setAgentName(toProperCase(e.target.value))} InputLabelProps={{ shrink: Boolean(agentName) }} variant="outlined" size="small" sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }} />
                        </Box>
                        <Box sx={{ flex: '0 0 48%' }}>
                            <TextField fullWidth label="Agent Commission (%)" value={agentCommission} InputLabelProps={{ shrink: Boolean(agentCommission) }} variant="outlined" size="small" type="number"
                                onChange={e => {
                                    const v = e.target.value;
                                    if (v === '') {
                                        setAgentCommission('');
                                        return;
                                    }
                                    const re = /^(?:100(?:\.(?:0{0,2}))?|[0-9]{1,2}(?:\.\d{0,2})?)$/;
                                    if (re.test(v)) {
                                        setAgentCommission(v);
                                    }
                                }}
                                sx={{ '& .MuiOutlinedInput-root': { backgroundColor: 'white', height: '38px' }, '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 10px' } }}
                            />
                        </Box>
                    </Box>

                    <Box display="flex" gap={2} pt={2}>

                        <Box sx={{ flex: 1 }}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Due Days"
                                value={dueDays}
                                inputProps={{ inputMode: 'numeric' }}
                                onChange={(e) => {
                                    const v = e.target.value.replace(/[^0-9]/g, '');
                                    setDueDays(v);
                                    const base = qoutationDate ? dayjs(qoutationDate) : dayjs();
                                    setdueDate(base.add(Number(v) || 0, 'day'));
                                }}
                            />
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            <Autocomplete
                                fullWidth
                                size="small"
                                options={termsOptions}
                                getOptionLabel={(opt) => opt?.label || ''}
                                value={selectedTerms}
                                onChange={(_, v) => setSelectedTerms(v)}
                                inputValue={termsInputValue}
                                onInputChange={(_, newInputValue) => setTermsInputValue(newInputValue)}
                                noOptionsText="Not Found"
                                isOptionEqualToValue={(opt, val) => String(opt?.id) === String(val?.id)}
                                // disabled={!isEditable}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Terms"
                                        size="small"
                                        InputLabelProps={{ shrink: Boolean(selectedTerms || termsInputValue) }}
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                height: 38,
                                                display: 'flex',
                                                alignItems: 'center'
                                            },
                                            '& .MuiOutlinedInput-input': {
                                                fontSize: '0.875rem',
                                                padding: '0 12px'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </Box>
                    </Box>

                    <Box sx={{ flex: '0 0 48%' }} pt={2}>
                        {/* {dropdownField('Account', accountOptions, selectedAccount, setSelectedAccount, openClientPopup, setOpenClientPopup, true)} */}
                    </Box>
                </Box>
            </Box>

            {!!error && <Typography color="error" mt={2}>{error}</Typography>}

            <Box mt={4} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleNext} disabled={!selectedClientId || !isTransactionTypeValid || !selectedPurcACId}>Next</Button>
            </Box>

            {/* Popups */}
            <Dialog open={openClientPopup} fullWidth maxWidth="md" onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                setOpenClientPopup(false);
            }}
                PaperProps={{
                    sx: {
                        width: { xs: "95%", },
                        m: { xs: 0 }
                    }
                }}
            >
                <DialogContent sx={{ p: { xs: 0 } }}>
                    <ClientMaster mode="add" onPopupCancel={(data) => { handlePopupClose(data); setOpenClientPopup(false) }} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openCurrencyPopup} onClose={() => setOpenCurrencyPopup(false)}>
                <DialogContent>
                    <CurrencyMaster mode="add" onPopupCancel={() => setOpenCurrencyPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openLeadSourcePopup} onClose={() => setOpenLeadSourcePopup(false)}>
                <DialogContent>
                    <LeadSourceMaster mode="add" onPopupCancel={() => setOpenLeadSourcePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openEmployeePopup} onClose={() => setOpenEmployeePopup(false)}>
                <DialogContent>
                    <UserMaster mode="add" onPopupCancel={() => setOpenEmployeePopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openActivityPopup} onClose={() => setOpenActivityPopup(false)}>
                <DialogContent>
                    <ActivityMaster mode="add" onPopupCancel={() => setOpenActivityPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>
            <Dialog open={openStatusPopup} onClose={() => setOpenStatusPopup(false)}>
                <DialogContent>
                    <LeadStatusMaster mode="add" onPopupCancel={() => setOpenStatusPopup(false)} connectionString={connectionString} />
                </DialogContent>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} >
                <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }} >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Paper>
    );
}
